const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useContactUs = function (modal) {
  const { start, finish } = useLoadingIndicator();
  const rc = useRuntimeConfig();
  const toast = useToast();
  const { t, locale } = useI18n();
  const form = reactive({
    name: "",
    phone: "",
    email: "",

    nameError: false,
    phoneError: false,
    emailError: false,
  });
  async function sendForm() {
    form.nameError = !form.name.trim();
    form.phoneError = !form.phone.trim();
    form.emailError =
      !!form.email && !emailPattern.test(form.email.trim());

    if (form.nameError || form.phoneError || form.emailError) {
      return toast.add({
        title: t("fillForm"),
        color: "red",
      });
    }
    const body = {
      name: form.name,
      phone: form.phone,
      email: form.email,
    };
    try {
      start();
      await $fetch(rc.public.api + "/api/application/contact-us", {
        method: "POST",
        body,
      });
      toast.add({
        title: t("contactSuccess"),
      });

      resetForm();
      modal.value = false;
    } catch (error) {
      console.log(error);
      toast.add({
        title:
          error?.data?.context?.message ||
          error?.data?.message ||
          "Internal error",
        color: "red",
      });
    } finally {
      finish();
    }
  }
  function resetForm() {
    form.name = form.phone = form.email = "";
    form.nameError = form.phoneError = form.emailError = false;
  }

  return {
    form,
    sendForm,
  };
};
